"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const react_1 = require("react");
const hopper_action_1 = __importDefault(require("../hopper.action"));
const store_1 = require("store");
const app_types_1 = require("pages/app.types");
const app_action_1 = __importDefault(require("pages/app.action"));
const hopper_details_modal_1 = __importDefault(require("./hopper.details.modal"));
const hopper_history_modal_1 = __importDefault(require("./hopper.history.modal"));
const hopper_sub_component_1 = __importDefault(require("./hopper.sub-component"));
const hopper_mutation_component_1 = __importDefault(require("./hopper.mutation.component"));
const tab_1 = __importDefault(require("components/molecules/tabs/tab"));
const header_menu_1 = __importDefault(require("components/molecules/header-menu"));
const hopper_pos_1 = require("pages/hopper-pos");
const modal_1 = require("components/molecules/modal");
const authorization_1 = require("utils/authorization");
require("react-toastify/dist/ReactToastify.css");
const react_toastify_1 = require("react-toastify");
const Hopper = () => {
    var _a;
    const { onReset, isError, hex_tag, dataItem, isLoading, isSuccess, isPushLED, dataHauler, dataStates, listHauler, isSavedData, mutationMode, errorMessage, dataHopperLine, onCallWebSocket, isGetDataHauler, dataStatesHistory, isToast, messageToast } = (0, store_1.useAppSelector)((state) => state.hopper);
    const { appTheme } = (0, store_1.useAppSelector)((state) => state.app);
    const { userData } = (0, store_1.useAppSelector)((state) => state.auth);
    const { configurationCheckPointData: dataPos, checkpointChild, deviceData } = (0, store_1.useAppSelector)((state) => state.hopperPos);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [fullScreen, setFullScreen] = (0, react_1.useState)(true);
    const [cancelSubmit, setCancelSubmit] = (0, react_1.useState)(true);
    const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, 'Hopper');
    const accessOperatorHopper = (0, authorization_1.userOperatorAccess)(userData.operator_access, 'Hopper');
    const hopperTabs = checkpointChild.map((item, idx) => ({ index: idx, labels: item.checkpoint_name }));
    const [countdown, setCountdown] = (0, react_1.useState)(180);
    (0, react_1.useEffect)(() => {
        let timeoutId;
        const resetTimeout = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                resetTimeout();
                if (dataHauler.id == '') {
                    clearTimeout(autosave);
                    dispatch({ type: app_types_1.appTypes.RESET_LOADING });
                    dispatch(hopper_action_1.default.onReset({ onReset: !onReset }));
                    getHistory();
                    setCancelSubmit(true);
                }
            }, 180000);
            setCountdown(180);
        };
        const handleUserActivity = () => {
            resetTimeout();
        };
        window.addEventListener('mousemove', handleUserActivity);
        window.addEventListener('scroll', handleUserActivity);
        resetTimeout();
        const countdownInterval = setInterval(() => {
            setCountdown((prevCountdown) => prevCountdown - 1);
        }, 1000);
        return () => {
            clearTimeout(timeoutId);
            clearInterval(countdownInterval);
            window.removeEventListener('mousemove', handleUserActivity);
            window.removeEventListener('scroll', handleUserActivity);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        console.log(`Countdown: ${countdown}s`);
        if (countdown === 0) {
            console.log('User is idle.');
        }
    }, [countdown]);
    const [tabsMode, setTabsMode] = (0, react_1.useState)('');
    const hopperLed = dataHopperLine.find((el) => el.checkpoint_name.toLowerCase() === tabsMode.toLowerCase());
    const onChangeTab = (mode) => {
        setTabsMode(mode);
        const [findCheckpoint] = checkpointChild.filter(item => item.checkpoint_name === mode);
        dispatch(hopper_pos_1.hopperPosAction.getLandingPageHopper({ checkpoint_id: findCheckpoint.checkpoint_id }));
        dispatch({ type: app_types_1.appTypes.RESET_LOADING });
    };
    const url = `ws://${(_a = deviceData.find(i => i.name_device == 'PC')) === null || _a === void 0 ? void 0 : _a.ip_address}:${String(process.env.RFID_PORT)}`;
    const showToastMessage = () => {
        react_toastify_1.toast.error(messageToast, {
            position: react_toastify_1.toast.POSITION.TOP_CENTER
        });
    };
    (0, react_1.useEffect)(() => {
        if (location.protocol == 'http:') {
            const ws = new WebSocket(url);
            try {
                if (onCallWebSocket) {
                    ws.onopen = (i) => console.log('WS open for ', url, i);
                    ws.onmessage = function (event) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const { isError, data, errorMessage, errorType, ping } = JSON.parse(event.data);
                            try {
                                if (!isError) {
                                    if (hex_tag != data.hex_tag) {
                                        console.log('Success', url, data);
                                        setCancelSubmit(false);
                                        dispatch(hopper_action_1.default.getDataHauler(data.hex_tag));
                                    }
                                    else {
                                        console.log('Hauler already scanned');
                                    }
                                }
                                else {
                                    if (ping)
                                        dispatch(hopper_action_1.default.setStatus({ status: 'Online' }));
                                    console.log('Error', errorMessage);
                                }
                            }
                            catch (err) {
                                if (errorType != 'TIMEOUT')
                                    dispatch(hopper_action_1.default.onClickMutation({
                                        mutationMode: mutationMode,
                                        messageToast: errorMessage,
                                        isToast: true
                                    }));
                                if (ping)
                                    dispatch(hopper_action_1.default.setStatus({ status: 'Online' }));
                                console.log('Failed', err);
                            }
                        });
                    };
                    ws.onclose = () => console.log('ws closed ', url);
                }
            }
            catch (error) {
                console.error(error);
            }
            return () => {
                ws.close();
            };
        }
        return () => {
            console.log('Please use http');
        };
    }, [onCallWebSocket, dataPos.checkpoint_id]);
    (0, react_1.useEffect)(() => {
        if (location.protocol == 'http:') {
            const ws = new WebSocket(url);
            try {
                ws.onopen = () => console.log('Pinging.. ', url);
                ws.onmessage = function (event) {
                    return __awaiter(this, void 0, void 0, function* () {
                        const { ping } = JSON.parse(event.data);
                        try {
                            if (!ping) {
                                dispatch(hopper_action_1.default.setStatus({ status: 'Offline' }));
                            }
                            else {
                                dispatch(hopper_action_1.default.setStatus({ status: 'Online' }));
                            }
                        }
                        catch (err) {
                            console.log(err);
                        }
                    });
                };
            }
            catch (error) {
                console.error(error);
            }
            return () => {
                ws.close();
            };
        }
        return () => {
            console.log('Please use http');
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (mutationMode === 'passive') {
            if (listHauler.length == 0)
                dispatch(hopper_action_1.default.getDataHopperList());
        }
    }, [mutationMode]);
    (0, react_1.useEffect)(() => {
        const intervalId = setInterval(() => {
            if (isSuccess) {
                dispatch(hopper_action_1.default.onDataStateChangeHistory(dataStates));
                dispatch(hopper_action_1.default.onClickMutation({ mutationMode: false, isSuccess: false, onCallWebSocket: true, dataHauler }));
            }
        }, 1000);
        return () => clearInterval(intervalId);
    }, [isSuccess]);
    (0, react_1.useEffect)(() => {
        if (dataPos)
            dispatch(hopper_action_1.default.pushLED(dataPos));
    }, [
        dataPos
    ]);
    (0, react_1.useEffect)(() => {
        if (isToast) {
            showToastMessage();
            dispatch(hopper_action_1.default.onClickMutation({
                mutationMode: mutationMode,
                messageToast: '',
                isToast: false
            }));
        }
    }, [isToast]);
    (0, react_1.useEffect)(() => {
        if (isAuthorized.view) {
            if (isLoading)
                dispatch(hopper_action_1.default.getDataHopperLine(dataStates));
            dispatch(hopper_action_1.default.setDataHopperTabs({ dataHopperTabs: hopperLed, dataHauler }));
            if (accessOperatorHopper.length > 0 && checkpointChild.length === 0) {
                navigate('/choose-pos-hopper');
            }
            if (accessOperatorHopper.length === 1 && checkpointChild.length === 0) {
                const [{ checkpoint_child }] = accessOperatorHopper;
                if (checkpoint_child) {
                    const [{ checkpoint_id }] = checkpoint_child;
                    dispatch(app_action_1.default.appActionSelectMenu({ menu: 'Hopper', subMenu: null }));
                    dispatch(hopper_pos_1.hopperPosAction.getLandingPageHopper({ checkpoint_id: checkpoint_id }));
                    dispatch(hopper_pos_1.hopperPosAction.setSelectedChild({ checkpointChild: checkpoint_child }));
                }
            }
            if (checkpointChild.length > 0) {
                const [{ checkpoint_name }] = checkpointChild;
                setTabsMode(checkpoint_name);
            }
        }
        else {
            navigate('/dashboard', { replace: true });
        }
    }, [isAuthorized, fullScreen, isPushLED, tabsMode, checkpointChild]);
    let autosave;
    (0, react_1.useEffect)(() => {
        if (isGetDataHauler && mutationMode == false) {
            autosave = setTimeout(() => {
                submit();
            }, 10000);
        }
    }, [isGetDataHauler, mutationMode]);
    const submit = () => {
        const hauler = dataHauler;
        if (hauler.id !== '')
            dispatch(hopper_action_1.default.postDataHauler({
                dataHauler: Object.assign(Object.assign({}, hauler), { transaction_type: 'normal', checkpoint_id: dataPos.checkpoint_id }),
                isCancel: cancelSubmit
            }));
    };
    (0, react_1.useEffect)(() => {
        if (isSavedData) {
            setTimeout(() => {
                getHistory();
                dispatch(hopper_action_1.default.pushLED(dataPos));
                dispatch({ type: app_types_1.appTypes.RESET_LOADING });
            }, 30000);
        }
    }, [isSavedData]);
    (0, react_1.useEffect)(() => {
        widthCheker();
    }, []);
    (0, react_1.useEffect)(() => {
        if (dataHauler.contractor_id != '') {
            dispatch(hopper_action_1.default.getDataDropdown({ contractor_id: dataHauler.contractor_id }));
        }
    }, [dataHauler.contractor_id]);
    (0, react_1.useEffect)(() => {
        if (mutationMode === false && dataPos.checkpoint_id) {
            const newDataStatesHistory = Object.assign(Object.assign({}, dataStatesHistory), { skip: mutationMode == false ? 0 : dataStatesHistory.skip, take: mutationMode == false ? 10 : dataStatesHistory.take, sort: [{ field: 'modified_date', dir: 'desc' }], filter: {
                    logic: 'and',
                    filters: [{
                            operator: 'uuid',
                            field: 'checkpoint_id',
                            value: dataPos.checkpoint_id
                        }],
                } });
            dispatch(hopper_action_1.default.getDataHistory(newDataStatesHistory));
        }
    }, [mutationMode, dataPos, isSuccess]);
    //checkfullscreen
    const widthCheker = () => {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        setFullScreen(width >= window.screen.width);
    };
    const getHistory = () => {
        if (dataPos.checkpoint_id !== '') {
            const newDataStatesHistory = Object.assign(Object.assign({}, dataStatesHistory), { skip: mutationMode == false ? 0 : dataStatesHistory.skip, take: mutationMode == false ? 10 : dataStatesHistory.take, filter: {
                    logic: 'and',
                    filters: [{
                            operator: 'uuid',
                            field: 'checkpoint_id',
                            value: dataPos.checkpoint_id
                        }]
                } });
            dispatch(hopper_action_1.default.getDataHistory(newDataStatesHistory));
        }
    };
    window.onload = widthCheker;
    window.onresize = widthCheker;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: {
            width: fullScreen ? 'auto' : 'max-content',
            height: 'inherit',
        } }, { children: [(0, jsx_runtime_1.jsx)(header_menu_1.default, { title: 'Hopper', theme: appTheme, isLoading: isLoading, isHistory: isAuthorized.view, isReset: isAuthorized.view, onHistory: () => {
                    getHistory();
                    dispatch(hopper_action_1.default.onClickMutation({
                        mutationMode: 'history', dataHauler, dataItem, isSavedData, isGetDataHauler
                    }));
                }, onReset: () => {
                    clearTimeout(autosave);
                    dispatch({ type: app_types_1.appTypes.RESET_LOADING });
                    dispatch(hopper_action_1.default.onReset({ onReset: !onReset }));
                    getHistory();
                    setCancelSubmit(true);
                } }), (0, jsx_runtime_1.jsx)(tab_1.default, { tabs: hopperTabs, onChangeTab: onChangeTab }), (0, jsx_runtime_1.jsx)(modal_1.ModalSuccess, { show: isSuccess, style: { zIndex: 10 }, appTheme: appTheme, messageSuccess: 'Data saved Successfully', onClose: () => {
                    dispatch(hopper_action_1.default.onDataStateChangeHistory(dataStates));
                    dispatch(hopper_action_1.default.onClickMutation({ mutationMode: false, isSuccess: false }));
                } }), (0, jsx_runtime_1.jsx)(modal_1.ModalError, { show: isError, appTheme: appTheme, style: { zIndex: 10 }, errorMessage: errorMessage, onClose: () => {
                    dispatch(hopper_action_1.default.toggleError({ isError: false, errorCode: 0, errorMessage: '' }));
                    dispatch(hopper_action_1.default.onClickMutation({
                        mutationMode: mutationMode == 'passive' || mutationMode == 'modify' ? mutationMode : false,
                        dataHauler
                    }));
                } }), (0, jsx_runtime_1.jsx)(react_toastify_1.ToastContainer, { style: { zIndex: 8 } }), mutationMode === 'history' && (0, jsx_runtime_1.jsx)(hopper_history_modal_1.default, {}), mutationMode === 'details' && (0, jsx_runtime_1.jsx)(hopper_details_modal_1.default, {}), (0, jsx_runtime_1.jsx)(hopper_mutation_component_1.default, { isAuthorized: isAuthorized }), (0, jsx_runtime_1.jsx)(hopper_sub_component_1.default, { isAuthorized: isAuthorized })] })));
};
exports.default = Hopper;
